// extracted by mini-css-extract-plugin
export default {"content":"MainContent_content__IAnof"};